<!-- Header -->
<header class="header text-white pt-12 pb-10" style="background-image: linear-gradient(-45deg, #667eea 0%, #764ba2 100%);">
  <div class="container">
    <h1 class="display-4">{{ title }}</h1>
    <p class="lead-2 mt-6">{{ subtitle }}</p>
  </div>
</header><!-- /.header -->